module.exports = __webpack_public_path__ + "img/instagram_logo.b2fab4bf.svg";